module.exports = __webpack_public_path__ + "media/images/signatures/laci_signature_black-91dc4c398d2a39457e4b334f46e52e85.png";